import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-107d5fc0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "font-weight": "800",
    "font-size": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left fontCoarse"
}, "时间", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "让胜"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "让平"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "让负"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_6 = {
  class: "left fontCoarse"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "u-batNum"
};
const _hoisted_9 = {
  key: 0,
  class: "u-img"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  key: 1,
  class: "u-img"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  key: 2,
  class: "u-img"
};
const _hoisted_16 = {
  class: "content"
};
const _hoisted_17 = {
  class: "u-batNum"
};
const _hoisted_18 = {
  key: 0,
  class: "u-img"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = {
  key: 1,
  class: "u-img"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_23 = [_hoisted_22];
const _hoisted_24 = {
  key: 2,
  class: "u-img"
};
const _hoisted_25 = {
  class: "content"
};
const _hoisted_26 = {
  class: "u-batNum"
};
const _hoisted_27 = {
  key: 0,
  class: "u-img"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png"
}, null, -1));
const _hoisted_29 = [_hoisted_28];
const _hoisted_30 = {
  key: 1,
  class: "u-img"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png"
}, null, -1));
const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = {
  key: 2,
  class: "u-img"
};
import { ref } from 'vue';
export default {
  __name: 'HHadList',
  setup(__props, {
    expose: __expose
  }) {
    const hhadList = ref([]);
    const goalLine = ref('-1');
    const firstOption = ref('无');
    const secondOption = ref('无');
    const pushHHadList = list => {
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          goalLine.value = list[i].goalLine;
          let s = list[i].updateDate.split('-');
          list[i].date = s[1] + '-' + s[2];
        }
      }
      hhadList.value = list;
      let hL = [];
      let dL = [];
      let aL = [];
      for (let i = 0; i < list.length; i++) {
        hL[i] = parseFloat(list[i].h);
        dL[i] = parseFloat(list[i].d);
        aL[i] = parseFloat(list[i].a);
      }
      let hLS = computeDiscrepancy(hL);
      let dLS = computeDiscrepancy(dL);
      let aLs = computeDiscrepancy(aL);
      let numbers = [hLS, dLS, aLs];
      numbers = numbers.slice().sort((a, b) => a - b);
      if (list.length > 1) {
        if (numbers[0] == hLS) {
          firstOption.value = '让胜';
        } else if (numbers[0] == dLS) {
          firstOption.value = '让平';
        } else {
          firstOption.value = '让负';
        }
        if (numbers[1] == hLS) {
          secondOption.value = '让胜';
        } else if (numbers[1] == dLS) {
          secondOption.value = '让平';
        } else {
          secondOption.value = '让负';
        }
      }
    };
    const computeDiscrepancy = array => {
      if (!Array.isArray(array) || array.length === 0) {
        return 0;
      }
      const mean = array.reduce((sum, value) => sum + value, 0) / array.length;
      return array.reduce((discrepancy, value) => {
        return discrepancy + Math.abs(value - mean);
      }, 0);
    };
    // 暴露给外部使用的函数
    __expose({
      pushHHadList
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("(" + _toDisplayString(goalLine.value) + ")让球胜平负", 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_1, "让球胜平负 推荐 首选：" + _toDisplayString(firstOption.value) + " 次选：" + _toDisplayString(secondOption.value), 1), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hhadList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 9
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(change.date) + " " + _toDisplayString(change.updateTime), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(change.h), 1), change.hf == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11)) : change.hf == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_14)) : (_openBlock(), _createElementBlock("span", _hoisted_15))])]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(change.d), 1), change.df == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_20)) : change.df == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_23)) : (_openBlock(), _createElementBlock("span", _hoisted_24))])]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(change.a), 1), change.af == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_29)) : change.af == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_30, _hoisted_32)) : (_openBlock(), _createElementBlock("span", _hoisted_33))])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))], 64);
    };
  }
};